<template>
  <div
    class="dbc-c-btn-container"
    :data-aos="aos?.fadeDirection"
    :data-aos-delay="aos?.delay"
  >
    <NuxtLink
      :class="[`dbc-gc-btn dbc-gc-btn--${button.type}`, { className }]"
      :to="button.link"
      :target="resolveLinkTarget(button.link)"
    >
      <i v-if="button.icon?.pos === 'prefix'" class="dbc-gc-btn__icon">
        <component
          :is="isPreview() ? 'img' : NuxtImg"
          width="24"
          height="24"
          :src="`${useRuntimeConfig().public.cms}${button.icon.media.url}`"
        />
      </i>

      {{ text }}

      <i v-if="button.icon?.pos === 'suffix'" class="dbc-gc-btn__icon">
        <component
          :is="isPreview() ? 'img' : NuxtImg"
          width="24"
          height="24"
          :src="`${useRuntimeConfig().public.cms}${button.icon.media.url}`"
        />
      </i>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { NuxtImg } from '#components'

const props = defineProps<{
  className?: string
  button: Button
  aos?: Aos
}>()

const text = ref<string>(props.button.text)

const isPdfRegex = /([\w\s\.\:\/-]+\.[pP][dD][fF])/g

if (props.button.link.match(isPdfRegex)) {
  text.value = `${text.value} (PDF)`
}
</script>
